import axios from "axios";
import { csrfInstance } from "../utils/csrfHelper";
import { ApiConstants } from "../constants/api";
export class BaseApi {
    /**
     * Abstract entity service.
     * @param baseEntity name of the entity, e.g. 'product'. Is used to construct http endpoint: https://ex.com/rest/{baseEntity}
     * @param baseApiUrl base URL for the client. Defaults to the REST API ({@link ApiConstants.REST_URL}).
     * @param withCredentials send/receive cookies (session) — defaults to true.
     * @protected
     */
    constructor(baseEntity, baseApiUrl = ApiConstants.REST_URL, withCredentials = true) {
        this.baseEntity = baseEntity;
        this.baseApiUrl = baseApiUrl;
        this.withCredentials = withCredentials;
        this.headers = {
            "Content-Type": "application/json"
        };
    }
    /**
     * Creates an Axios client bound to {@code url} (defaults to {@link baseApiUrl}).
     * CSRF headers are attached via a request interceptor so the token from the
     * server-rendered <meta> tags is always current. Axios' built-in XSRF handling
     * is disabled because CSRF is managed explicitly through these headers.
     */
    createClient(url) {
        const client = axios.create({
            baseURL: url !== null && url !== void 0 ? url : this.baseApiUrl,
            withCredentials: this.withCredentials,
            headers: { "Content-Type": "application/json" },
            xsrfCookieName: "",
            xsrfHeaderName: ""
        });
        client.interceptors.request.use((config) => {
            Object.assign(config.headers, csrfInstance.getHeaders());
            return config;
        });
        return client;
    }
    getAxios() {
        return this.createClient();
    }
    /**
     * Fetches a list of T records
     * @param id record id
     * @param endpoint url param that goes after {baseEntity}: https://ex.com/rest/{baseEntity}/{endpoint}
     */
    async get(id, endpoint) {
        const url = this.baseEntity + (endpoint ? endpoint : "/" + id);
        const response = await this.getAxios().get(url);
        if (response.status !== 200) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        console.log(`Fetched record[id = ${id}]`);
        return response.data;
    }
    /**
     * Sends a POST request with a given body
     * @param id record id (optional)
     * @param path additional API path
     * @param body request payload
     */
    async post(id, path, body) {
        const url = this.baseEntity + path;
        console.log("Fetching URL:", url);
        console.log("Headers:", this.headers);
        console.log("Body:", body);
        const response = await this.getAxios().post(url, body);
        if (response.status !== 200) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        console.log(`Sent record[id=${id}]`);
        return response.data;
    }
}
